import { Suspense } from 'react'
import { AppBar, Toolbar } from '@mui/material'
import styled from 'styled-components/macro'
import { spacing, theme } from 'src/utils/styled'
import traiwissLogo from 'src/assets/traiwiss_logo.png'

const StyledAppBar = styled(AppBar)`
    z-index: ${theme((t) => t.zIndex.drawer + 1)};
`

const Spacer = styled.div`
    width: ${spacing(3)};
`

const StyledImage = styled.img`
    height: 30px;
    margin: ${spacing(1)};
`

export function Topbar() {
    return (
        <Suspense fallback={<></>}>
            <StyledAppBar position="fixed" color="secondary">
                <Toolbar>
                    <StyledImage src={traiwissLogo} alt="traiwiss logo" />
                    <Spacer />
                </Toolbar>
            </StyledAppBar>
        </Suspense>
    )
}
